<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'kycDetailDialog',
  mixins: [snackbarMixin],
  props: {
    isCreateMode: {
      type: Boolean,
    },
    item: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      visible: false,
      hasError: false,
      formData: {},
      files: [],
      baseUrl: 'https://onayapi.summa.com.tr:8098/', // temel URL
      statusList: [],
    };
  },
  computed: {
    ...mapState({
      isKysAdmin: state => state.isKysAdmin
    }),
    
  },
  created() {
    if (!this.isCreateMode) {
      this.formData = Object.assign({}, this.item);
    } else {
      this.formData = {};
    }
  },
  mounted() {
    this.visible = true;
    this.initializeData();
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('kycFormu',['getDetail']),
    ...mapMutations('kycFormu', ['getList']),
    fetchData() {
    },
    initializeData() {
    },
    getFileName(filePath) {
      // Dosya yolunu "/" ile bölelim ve son parçayı (dosya adını) döndürelim
      const pathSegments = filePath.split('/');
      return pathSegments[pathSegments.length - 1];  // Son parçayı alıyoruz, yani dosya adını
  } ,
    async submit() {
      this.hasError = false;

      if(this.formData.tedarikciUnvani === undefined || this.formData.tedarikciUnvani == ""){
        this.hasError = true;
      }
      
      
       if(this.hasError){
        return;
       }

       if (this.files.length > 0) {
          const formData = new FormData();
          formData.append('kycFormu', JSON.stringify(this.formData));

          // Birden fazla dosya yükleniyorsa, hepsini FormData'ya ekliyoruz
          this.files.forEach((file, index) => {
            formData.append(`fileDetails[${index}].FileDetails`, file);  // formFiles[0], formFiles[1] şeklinde ekliyoruz
            formData.append(`fileDetails[${index}].FileType`, '2');  // formFiles[0], formFiles[1] şeklinde ekliyoruz
          });

        var response = await this.$store.dispatch('kycFormu/saveWithFile', formData);
        if (response.status === 200 && response.data > 0) {
          this.showSuccessMessage('Form kaydedildi');
          this.fetchData();
          this.$emit('close');
        } else {
          this.hasError = true;
          this.showErrorMessage(response.data);
        }
      }
      else{
      this.$emit('save', this.formData);
      }

    },
    async handleFileUpload(files) {
      this.files = files;
    },
    close() {
      this.$emit('close');
    },
    deleteKyc(){
      this.$emit('delete', this.formData.id);
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible" persistent max-width="1200px">
    <v-card>
      <v-card-title>
        {{ $t('kycFormTitle') }}
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex xs6 md1 py-0>
              <v-text-field
                v-model="formData.id"
                :label="$t('code')"
                height="22"
                class="caption"
                readonly
              />
            </v-flex>
            <v-flex xs12 md3 py-0>
              <v-text-field
                v-model="formData.olusturanKullanici"
                :label="$t('createdBy')"
                height="22"
                class="caption"
                readonly
              />
            </v-flex>
            <v-flex xs12 md2 py-0>
              <v-text-field
                v-model="formData.olusturmaTarihi"
                :label="$t('createDate')"
                height="22"
                class="caption"
                readonly
                dateWithTimeView
              />
            </v-flex>
            <v-flex xs12 md3 py-0>
              <v-text-field
                v-model="formData.guncelleyenKullanici"
                :label="$t('modifiedBy')"
                height="22"
                class="caption"
                readonly
              />
            </v-flex>
            <v-flex xs12 md2 py-0>
              <v-text-field
                v-model="formData.guncellemeTarihi"
                :label="$t('modifiedDate')"
                height="22"
                class="caption"
                readonly
                dateWithTimeView
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.tedarikciUnvani"
                :label="$t('vendorName')"
                height="22"
                class="caption"
                required
                :rules="[v => !!v || 'Tedarikçi ünvanı zorunlu bir alandır']"
              >
                <template v-slot:label>
                  {{ $t('vendorName') }} <span style="color: red;">*</span>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.vergiNo"
                :label="$t('identityOrPassportNumber')"
                identityOrPassportNumber
                height="22"
                class="caption"
                required
                :rules="[v => !!v || 'Vergi / Kimlik No zorunlu bir alandır']"
              >
                <template v-slot:label>
                  {{ $t('identityOrPassportNumber') }} <span style="color: red;">*</span>
                </template>
              </v-text-field>
            </v-flex>

            <v-flex xs12 md12 py-0>
              <v-radio-group v-model="formData.isQuestion1" :label="$t('kycQuestion')" required>
                <v-radio :label="$t('yes')" :value="true"></v-radio>
                <v-radio :label="$t('no')" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>

            <v-flex xs12 md12 py-0 v-if="formData.isQuestion1">
              {{ $t('kycFileDefaultDownloadUrl') }}
               <a href="https://onay.summa.com.tr/kyc/kyc.docx">{{ $t('click') }}</a>.<br/>
              {{ $t('kycFileDefaultDownloadUrl_en') }} <a href="https://onay.summa.com.tr/kyc/kyc_eng.docx">{{ $t('click') }}</a>.<br/>
              <v-flex xs12 md12 pf-0>
                <v-file-input
                    v-model="files"
                    :label="$t('uploadKycForm')"
                    accept=".doc, .docx, .pdf"
                    multiple                 
                    @change="handleFileUpload"
                  ></v-file-input>
              </v-flex>
            </v-flex>
          <v-flex xs12 md12 py-0 v-if="formData.kycDocuments && formData.kycDocuments.length > 0">
            <div v-for="(document, index) in formData.kycDocuments" :key="index" class="d-flex align-center">
              <!-- Yüklenen KYC Formu -->
              <v-flex xs7 md7 py-0 class="d-flex align-center">
                {{ $t('uploadedKycForm') }} &nbsp;<strong>{{ getFileName(document.path) }}</strong>  &nbsp;&nbsp&nbsp;&nbsp;
                <a :href="`${baseUrl}${document.path}`" target="_blank">
                  {{ $t('click') }}
                </a>
              </v-flex>
              
              <!-- Yükleyen -->
              <v-flex xs3 md3 py-0 class="d-flex align-center">
                <v-text-field
                  v-model="document.createdBy"
                  :label="$t('uploadedBy')"
                  height="22"
                  class="caption"
                  readonly
                />
              </v-flex>
              
              <!-- Yükleme Tarihi -->
              <v-flex xs2 md2 py-0 class="d-flex align-center">
                <v-text-field
                  v-model="document.createdDate"
                  :label="$t('uploadDate')"
                  height="22"
                  class="caption"
                  readonly
                  dateWithTimeView
                />
              </v-flex>
            </div>
          </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>


      <v-card-actions>
        <v-spacer />
        <v-btn color="red lighten-3" dark @click="close">
          {{ $t('close') }}
        </v-btn>
        <v-btn color="red lighten-3" dark @click="deleteKyc" v-if="isKysAdmin">
          {{ $t('delete') }}
        </v-btn>
        <v-btn color="success" @click="submit">
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>
